"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage1 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig1.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import { fragenRestwertfinanzierungAutoVerkaufen } from "./data";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function RestwertfinanzierungAutoVerkaufen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Restwertfinanzierung Auto – Chancen, Risiken und Verkaufstipps"
        link="/guides/restwertfinanzierung-auto-verkaufen"
        linkname="Restwertfinanzierung Auto verkaufen"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung für dein Auto mit
            Restwertfinanzierung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Ist es möglich, ein Auto mit Restschuld zu verkaufen?"
              leftText={
                <>
                  <p>
                    Die Restwertfinanzierung, auch Ballonfinanzierung oder
                    Drei-Wege-Finanzierung genannt, erfreut sich bei
                    Neuwagenkäufern großer Beliebtheit. Sie lockt mit niedrigen
                    monatlichen Raten, weil während der Laufzeit hauptsächlich
                    die Wertminderung des Fahrzeugs bezahlt wird. Am Vertragsende
                    bleibt ein größerer Restbetrag offen, der sich am kalkulierten
                    Wiederverkaufswert orientiert. Doch lohnt sich diese
                    Finanzierung für jeden? Und was passiert, wenn man das
                    finanzierte Auto vorzeitig verkaufen möchte? Dieser Ratgeber
                    beleuchtet die Funktionsweise der Restwertfinanzierung, wägt
                    Vor- und Nachteile ab und zeigt dir, wie du dein Auto trotz
                    Restwertfinanzierung erfolgreich verkaufen kannst.
                  </p>
                </>
              }
              rightFirstTitle="Was ist eine Restwertfinanzierung?"
              rightFirstText={
                <>
                  <p>
                    Bei der Restwertfinanzierung bestimmt der Kreditgeber einen
                    kalkulierten Restwert, den das Fahrzeug nach Ablauf der
                    Laufzeit voraussichtlich besitzen wird. Dieser Wert hängt von
                    Marke, Modell, Ausstattung, Laufleistung und allgemein vom
                    Wertverlust ab. Die monatliche Rate setzt sich vor allem aus
                    Zinsen und der Differenz zwischen Kaufpreis und Restwert
                    zusammen.
                  </p>

                  <p>Am Ende der Laufzeit gibt es mehrere Optionen:</p>

                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Schlussrate zahlen und Auto behalten:</strong> Du
                      bezahlst den Restbetrag (Ballonrate) mit einem Schlag und
                      das Fahrzeug gehört dir.
                    </li>
                    <li>
                      <strong>Anschlussfinanzierung:</strong> Du finanzierst die
                      Schlussrate weiter, wodurch sich die Laufzeit verlängert.
                      Achtung: Hier können höhere Zinsen anfallen.
                    </li>
                    <li>
                      <strong>Auto zurückgeben:</strong> Du gibst das Fahrzeug an
                      den Händler zurück. Dieser prüft den Zustand – bei
                      übermäßiger Nutzung oder Schäden werden Nachzahlungen
                      fällig.
                    </li>
                    <li>
                      <strong>Auto verkaufen:</strong> Du verkaufst das Fahrzeug
                      eigenständig. Ist der Erlös höher als die Restschuld,
                      profitierst du; andernfalls musst du draufzahlen.
                    </li>
                  </ul>

                  <h3>Vorteile der Restwertfinanzierung</h3>
                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Niedrige Monatsraten:</strong> Dadurch bleibt dein
                      monatliches Budget flexibel. Du zahlst nur die kalkulierte
                      Wertminderung.
                    </li>
                    <li>
                      <strong>Flexibilität:</strong> Am Ende der Laufzeit hast du
                      die Wahl zwischen Kaufen, Weiterfinanzieren, Rückgabe oder
                      Verkauf.
                    </li>
                    <li>
                      <strong>Planbare Laufzeit:</strong> Die Laufzeit (meist 3–5
                      Jahre) ist fest definiert; das kann für Planbarkeit sorgen.
                    </li>
                    <li>
                      <strong>Attraktive Option für Vielfahrer?</strong> Nicht
                      unbedingt – bei hoher Laufleistung steigt das Risiko, dass
                      der tatsächliche Restwert niedriger ist als kalkuliert.
                    </li>
                  </ul>

                  <h3>Risiken und Nachteile</h3>
                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Hohe Schlussrate:</strong> Der Restbetrag kann
                      mehrere Tausend Euro betragen. Wenn du ihn nicht aufbringen
                      kannst, muss er weiterfinanziert werden.
                    </li>
                    <li>
                      <strong>Zinsrisiko:</strong> Die Gesamtkosten sind oft höher
                      als bei klassischen Ratenkrediten, da der Kreditgeber das
                      Restwertrisiko einpreist.
                    </li>
                    <li>
                      <strong>Restwertrisiko:</strong> Der tatsächliche Marktwert
                      kann niedriger ausfallen als prognostiziert. Schäden, hohe
                      Laufleistungen oder Markteinflüsse senken den
                      Wiederverkaufswert, du musst nachzahlen.
                    </li>
                    <li>
                      <strong>Vertragsbindung:</strong> Während der Laufzeit bist
                      du an den Vertrag gebunden. Eine vorzeitige Kündigung ist
                      mit Kosten verbunden.
                    </li>
                  </ul>
                </>
              }
              rightSecondTitle="Auto mit Restwertfinanzierung verkaufen – so geht’s"
              rightSecondText={
                <>
                  <ol className="custom-ordered-list">
                    <li>
                      <strong>Aktuellen Restwert und Restschuld ermitteln:</strong>{" "}
                      Nimm Kontakt mit der finanzierenden Bank oder dem Autohaus
                      auf und frage nach der aktuellen Restschuld sowie der Höhe
                      des kalkulierten Restwerts. Lasse dir die Ablösesumme
                      schriftlich bestätigen.
                    </li>
                    <li>
                      <strong>Fahrzeugwert feststellen:</strong>{" "}
                      Bewerte dein Auto anhand von Marktvergleichen,
                      Online-Bewertungen und Gutachten. Berücksichtige Schäden,
                      Sonderausstattungen und Kilometerstand. Nur wenn der
                      Verkaufserlös über der Restschuld liegt, lohnt sich ein
                      Verkauf.
                    </li>
                    <li>
                      <strong>Möglichkeiten prüfen:</strong>
                      <ul className="custom-unordered-list secondary">
                        <li>
                          <strong>Privater Verkauf:</strong> Du löst den Kredit
                          ab, erhältst die Zulassungsbescheinigung Teil II von der
                          Bank und kannst das Auto verkaufen. Der Erlös muss die
                          Restschuld decken; sonst musst du draufzahlen.
                        </li>
                        <li>
                          <strong>Kreditübernahme:</strong> Einige Banken
                          erlauben, dass der Käufer die Finanzierung übernimmt. Er
                          tritt an deine Stelle in den Vertrag und zahlt die
                          verbleibenden Raten. Er benötigt dafür Bonität und die
                          Zustimmung der Bank.
                        </li>
                        <li>
                          <strong>Verkauf an Händler oder über Autoeinfachlos:</strong>{" "}
                          Händler haben Erfahrung mit Ablösungen. Sie zahlen deine
                          Restschuld direkt an die Bank, nehmen dir das Auto ab und
                          überweisen dir den Differenzbetrag. Autoeinfachlos
                          vermittelt dir solche Händlerangebote.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Kaufvertrag und Ablösung organisieren:</strong>{" "}
                      Sobald du einen Käufer gefunden hast, erstellst du einen
                      Kaufvertrag und organisierst die Ablösung des Kredits. Im
                      Vertrag sollte vermerkt sein, dass der Kredit noch besteht
                      und von dir oder dem Händler abgelöst wird. Die Bank händigt
                      dir nach Zahlung die Zulassungsbescheinigung Teil II aus, die
                      du dem Käufer übergibst.
                    </li>
                    <li>
                      <strong>Schlussrate bedenken:</strong>{" "}
                      Plane, wie du die Ballonrate aufbringst, falls du das Auto
                      behalten möchtest. Manche Banken erlauben, diese Summe zu
                      strecken oder mittels Anschlusskredit zu finanzieren.
                      Vergleiche dabei die Zinsen.
                    </li>
                  </ol>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage1}
                revert
                h2
                isBig
                fontSize="36px"
                title="Tipps für den Abschluss einer Restwertfinanzierung"
                alt="Tipps fuer den Abschluss einer Restwertfinanzierung"
                text={
                  <>
                    <ul className="custom-unordered-list secondary">
                      <li>
                        <strong>Vertragsdetails prüfen:</strong> Achte auf
                        Zinssatz, Laufzeit, kalkulierte Kilometerleistung,
                        Kosten bei Rückgabe und mögliche Bearbeitungsgebühren.
                      </li>
                      <li>
                        <strong>Wirkliche Nutzung einschätzen:</strong> Fahre
                        nicht wesentlich mehr Kilometer als vereinbart.
                        Übersteigt die Nutzung den Vertrag, drohen hohe
                        Nachzahlungen.
                      </li>
                      <li>
                        <strong>Inspektionen einhalten:</strong> Ein
                        scheckheftgepflegtes Auto erhöht den Wiederverkaufswert.
                      </li>
                      <li>
                        <strong>Rückgabekriterien lesen:</strong> Informiere
                        dich, wie Schäden und Gebrauchsspuren bewertet werden.
                      </li>
                    </ul>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufig gestellte Fragen"
              fragen={fragenRestwertfinanzierungAutoVerkaufen}
              image={FAQImage}
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Restwertfinanzierung"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Thema Restwertfinanzierung"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ein Auto mit Restwertfinanzierung zu verkaufen."
                text={
                  <>
                    <p>
                      Die Restwertfinanzierung bietet niedrige Monatsraten und
                      Flexibilität, ist jedoch mit Risiken behaftet. Wer während
                      der Laufzeit oder am Ende verkaufen möchte, sollte
                      Restschuld und Marktwert genau vergleichen. Autoeinfachlos
                      erleichtert dir den Verkauf, indem wir die Ablösung der
                      Restwertfinanzierung übernehmen und dir faire Angebote
                      machen. So kannst du dich auf das Wesentliche konzentrieren
                      und dein Auto ohne finanziellen Scherbenhaufen verkaufen.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default RestwertfinanzierungAutoVerkaufen;
